'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as Sentry from "@sentry/core";
import { Platform, TouchableOpacity, View } from "react-native";
import { TouchableOpacity as GHTouchableOpacity } from "react-native-gesture-handler";
import doubleDownChevron from "../assets/icons/double-chevron-down";
import Icons from "../assets/icons/index";
import { solveColor } from "../lib/colorFilter";
import { addBreadcrumb } from "../lib/log";
import { isInteractionPaused } from "../lib/pauseInteraction";
import { useTheme } from "../styles";
var CUSTOM_ICONS = _object_spread_props(_object_spread({}, Icons), {
    'double-chevron-down': doubleDownChevron
});
/**
 * @private
 */ export function getIconNames() {
    return Object.keys(CUSTOM_ICONS);
}
/**
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-84}
 */ export function Icon(param) {
    var _useGestureHandler = param._useGestureHandler, _DANGER_NO_WRAPPER = param._DANGER_NO_WRAPPER, ariaLabel = param['aria-label'], color = param.color, dataSet = param.dataSet, disabled = param.disabled, _param_name = param.name, name = _param_name === void 0 ? 'check' : _param_name, _onPress = param.onPress, _param_size = param.size, size = _param_size === void 0 ? 20 : _param_size, style = param.style, testID = param.testID;
    var theme = useTheme().theme;
    color = color !== null && color !== void 0 ? color : theme.color.gray100;
    var onPress = _onPress ? function() {
        if (disabled) return;
        if (isInteractionPaused()) return;
        var _ref;
        addBreadcrumb({
            category: 'ui.click',
            message: (_ref = testID !== null && testID !== void 0 ? testID : ariaLabel) !== null && _ref !== void 0 ? _ref : typeof name === 'string' ? name : name.src,
            data: {
                componentType: 'Icon',
                testID: testID,
                name: name,
                'aria-label': ariaLabel
            }
        });
        _onPress === null || _onPress === void 0 ? void 0 : _onPress();
    } : _onPress;
    var CustomIcon = // {name: src}
    (typeof name === "undefined" ? "undefined" : _type_of(name)) === 'object' || // require('./path.svg').default => any
    typeof name === 'function' ? name : CUSTOM_ICONS[name];
    if (!CustomIcon) {
        Sentry.captureException('Missing icon', {
            extra: {
                name: name
            }
        });
        return null;
    }
    // if onPress is defined we set accessibilityLabel in the TouchableOpacity below
    var a11yProps = {
        'aria-label': onPress ? undefined : ariaLabel
    };
    var inner = CustomIcon && (typeof CustomIcon === "undefined" ? "undefined" : _type_of(CustomIcon)) === 'object' && 'src' in CustomIcon ? /*#__PURE__*/ _jsx("img", {
        src: CustomIcon.src,
        width: _DANGER_NO_WRAPPER !== null && _DANGER_NO_WRAPPER !== void 0 ? _DANGER_NO_WRAPPER : '100%',
        height: _DANGER_NO_WRAPPER !== null && _DANGER_NO_WRAPPER !== void 0 ? _DANGER_NO_WRAPPER : '100%',
        style: color === 'inherit' ? undefined : {
            filter: solveColor(color)
        }
    }) : /*#__PURE__*/ _jsx(CustomIcon, _object_spread_props(_object_spread({}, a11yProps), {
        color: color,
        width: _DANGER_NO_WRAPPER !== null && _DANGER_NO_WRAPPER !== void 0 ? _DANGER_NO_WRAPPER : '100%',
        height: _DANGER_NO_WRAPPER !== null && _DANGER_NO_WRAPPER !== void 0 ? _DANGER_NO_WRAPPER : '100%',
        preserveAspectRatio: "xMidYMid meet"
    }));
    if (_DANGER_NO_WRAPPER) return inner;
    var Component = _useGestureHandler ? GHTouchableOpacity : TouchableOpacity;
    return /*#__PURE__*/ _jsx(View, _object_spread_props(_object_spread({
        testID: testID,
        style: [
            style,
            size ? {
                width: size,
                height: size
            } : null
        ],
        // @ts-expect-error
        dataSet: _object_spread_props(_object_spread({}, dataSet), {
            icon: true
        })
    }, Platform.OS === 'ios' ? {
        accessible: false,
        'aria-label': 'icon wrapper',
        role: 'none'
    } : {}), {
        children: onPress ? /*#__PURE__*/ _jsx(Component, {
            disabled: disabled,
            onPress: onPress,
            accessible: true,
            role: "button",
            "aria-label": ariaLabel,
            "aria-disabled": disabled,
            hitSlop: {
                top: 10,
                right: 10,
                bottom: 10,
                left: 10
            },
            style: [
                {
                    height: '100%',
                    width: '100%'
                },
                disabled ? {
                    opacity: 0.5
                } : null
            ],
            children: inner
        }) : inner
    }));
}
